export function trackGrowth(eventName, metadata = {}) {
  if (typeof window === 'undefined') return;
  if (window.kyleGrowth?.track) {
    window.kyleGrowth.track(eventName, metadata);
    return;
  }
  window.__klGrowthQueue = window.__klGrowthQueue || [];
  window.__klGrowthQueue.push({ eventName, metadata });
}

export function trackGrowthOnce(eventName, key, metadata = {}) {
  if (typeof window === 'undefined') return;
  const storageKey = `dd_growth_${eventName}_${key}`;
  try {
    if (window.sessionStorage.getItem(storageKey)) return;
    window.sessionStorage.setItem(storageKey, '1');
  } catch {
    // Tracking remains non-blocking when storage is unavailable.
  }
  trackGrowth(eventName, metadata);
}
